import type { SVGProps } from 'react';
const SvgViewModule = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#view_module_svg__a)">
      <path
        fill="currentColor"
        d="M4 11h5V5H4v6Zm0 7h5v-6H4v6Zm6 0h5v-6h-5v6Zm6 0h5v-6h-5v6Zm-6-7h5V5h-5v6Zm6-6v6h5V5h-5Z"
      />
    </g>
    <defs>
      <clipPath id="view_module_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgViewModule;
